// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  --background: white;
}

.search {
  background: var(--ion-color-light-tint);
}
.search ion-searchbar {
  --background: white;
}

.mybutton {
  width: calc(106 * var(--width-ratio));
  height: calc(24 * var(--width-ratio));
  --background: var(--ion-color-primary-tint);
}

.label {
  margin-top: calc(16 * var(--width-ratio));
}

.myselect {
  margin-top: calc(8 * var(--width-ratio));
  background: rgba(162, 146, 193, 0.1);
  border-radius: 10px;
}
.myselect ::part(text) {
  color: var(--ion-color-dark-tint);
}

.mysearchbutton {
  --background: var(--ion-color-primary-tint);
  width: calc(283 * var(--width-ratio));
  height: calc(42 * var(--width-ratio));
  margin: auto;
  --border-radius: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modal/expert-filter-modal/expert-filter-modal.page.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,uCAAA;AACF;AACE;EACE,mBAAA;AACJ;;AAKA;EACE,qCAAA;EACA,qCAAA;EAEA,2CAAA;AAHF;;AAMA;EACE,yCAAA;AAHF;;AAMA;EACE,wCAAA;EACA,oCAAA;EACA,mBAAA;AAHF;AAKE;EACE,iCAAA;AAHJ;;AAOA;EACE,2CAAA;EACA,qCAAA;EACA,qCAAA;EACA,YAAA;EACA,qBAAA;AAJF","sourcesContent":["ion-toolbar {\n  --background: white;\n}\n\n.search {\n  background: var(--ion-color-light-tint);\n\n  ion-searchbar {\n    --background: white;\n    // padding-top: unset;\n    // padding-bottom: unset;\n  }\n}\n\n.mybutton {\n  width: calc(106 * var(--width-ratio));\n  height: calc(24 * var(--width-ratio));\n\n  --background: var(--ion-color-primary-tint);\n}\n\n.label {\n  margin-top: calc(16 * var(--width-ratio));\n}\n\n.myselect {\n  margin-top: calc(8 * var(--width-ratio));\n  background: rgba(162, 146, 193, 0.1);\n  border-radius: 10px;\n\n  ::part(text) {\n    color: var(--ion-color-dark-tint);\n  }\n}\n\n.mysearchbutton {\n  --background: var(--ion-color-primary-tint);\n  width: calc(283 * var(--width-ratio));\n  height: calc(42 * var(--width-ratio));\n  margin: auto;\n  --border-radius: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
